// KeepClose — "Keep Bloom one tap away": install on Android and desktop, the Share steps on
// iPhone, a bookmark shortcut everywhere else. Hidden when Bloom runs as an installed app, unless
// there is a WhatsApp channel link to show (B14, property co.obto.bloom.social).
import React, { useState } from "react";
import { fill } from "./i18n";
import { useMessages } from "./messages";
import { signal } from "./pulse";
import { useInstall } from "./pwa";
import { ChatIcon, useSocial } from "./social";

export const KEEP_ID = "keep";

export default function KeepClose() {
    const m = useMessages();
    const { mode, install } = useInstall();
    const { whatsapp } = useSocial();
    const [done, setDone] = useState(false);
    const installed = mode === "installed" && !done;
    if (installed && !whatsapp) return null;
    const key = /mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent || "") ? "⌘" : "Ctrl";

    let action: React.ReactNode = null;
    if (installed) {
        action = null;
    } else if (done) {
        action = <p className="rounded-xl bg-white/15 px-4 py-3 text-sm font-bold">✓ {m.keepDone}</p>;
    } else if (mode === "prompt") {
        action = (
            <button
                type="button"
                onClick={async () => { signal("app_tap", { s: "band_prompt" }); if (await install()) setDone(true); }}
                className="w-full rounded-xl bg-white px-5 py-3 text-sm font-extrabold text-green-800 shadow-lg transition hover:-translate-y-0.5 hover:bg-green-50 active:scale-95 md:w-auto"
            >
                📲 {m.keepInstall}
            </button>
        );
    } else if (mode === "ios" || mode === "android") {
        action = <p className="rounded-xl bg-white/15 px-4 py-3 text-sm font-semibold">{mode === "ios" ? m.keepIos : m.keepAndroid}</p>;
    } else {
        action = (
            <p className="rounded-xl bg-white/15 px-4 py-3 text-sm font-semibold">
                ★ {m.keepBookmark} — {fill(m.keepBookmarkHint, { key })}
            </p>
        );
    }

    return (
        <section id={KEEP_ID} className="mx-4 mb-6 mt-2 scroll-mt-44 overflow-hidden rounded-3xl bg-gradient-to-br from-green-700 via-green-600 to-emerald-500 p-6 text-white shadow-xl shadow-green-700/20 sm:mx-6 sm:p-8">
            <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
                <div className="flex items-start gap-4">
                    <img src="/api/bloom/icon/192" alt="" width={56} height={56} className="h-14 w-14 shrink-0 rounded-2xl shadow-lg ring-2 ring-white/30" />
                    <div>
                        <h2 className="text-xl font-extrabold leading-tight sm:text-2xl">{m.keepTitle}</h2>
                        <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-white/90">{m.keepBody}</p>
                    </div>
                </div>
                <div className="shrink-0 md:max-w-xs">
                    {action}
                    {whatsapp ? (
                        <>
                            <a
                                href={whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={"flex w-full items-center justify-center gap-2 rounded-xl border-2 border-white/70 px-5 py-2.5 text-sm font-extrabold text-white transition hover:bg-white/10 active:scale-95" + (action ? " mt-3" : "")}
                            >
                                <ChatIcon className="h-5 w-5" />
                                {m.waJoin}
                            </a>
                            <p className="mt-1.5 text-center text-xs text-white/85">{m.waDaily}</p>
                        </>
                    ) : null}
                </div>
            </div>
        </section>
    );
}
